import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { apiRoutes } from 'src/app/constants/apiRoutes';
import { ApiCallMethodsService } from 'src/app/shared/services/api-call-methods.service';
import { SharedService } from 'src/app/shared/services/shared-service/shared.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessContactsService {
  SharingData = new Subject();
  orgId: any = null;
  contactListData: any = null;
  customerPayload: any = {};
  cusPageSize: any = null;
  cusPage: any = null;


  constructor(
    private authService: AuthService,
    private apiCallMethodsService: ApiCallMethodsService,
    private sharedService: SharedService,

  ) {
    this.orgId = this.authService.getId();

    this.sharedService.customerSortUpdated.subscribe((data: any) => {

      if (this.contactListData && data?.from == 'customer-list' && (data?.sort || data?.remove == true)) {
        this.customerPayload.sort = data?.sort

        this.cutomerList(0, 10, this.customerPayload);
      };

      if (this.contactListData && data?.from == 'supplier-list'  && (data?.sort || data?.remove == true)) {
        this.customerPayload.sort = data?.sort;
        this.cutomerList(0, 10, this.customerPayload);
      }

    });
  }

  cutomerList(pageNumber, pageSize, payload: any = null) {

    this.customerPayload = payload;
    this.cusPage = pageNumber;
    this.cusPageSize = pageSize;

    let url = `${apiRoutes.contactVendorList}/${this.orgId}?page=${pageNumber}&pagesize=${pageSize}`;
    this.apiCallMethodsService.post(url, payload).subscribe((response: any) => {

      let data;

      this.contactListData = response;

      data = {
        contactListData: this.contactListData,
      }

      this.SharingData.next(data);

    },
      (error: any) => {

        let data = {
          contactListData: this.contactListData,
        }

        this.SharingData.next(data);

      });
  }


}
